// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PopUp_Wrapper__2cOHk","Container":"PopUp_Container__3p6ld"};